/**
 * @flow
 *
 * The deepLink epic.
 *
 * It takes in DEEP_LINK_REQUESTED actions and asks branch for deep links,
 * when the deep link returns it emits a DEEP_LINK_RECEIVED action.
 *
 */

import { DEEP_LINK_REQUESTED, deepLinkReceived } from '../redux/deepLinks';
import { getBranchSDK } from '../runtimeLibraries';

import type {
  ActionObserver,
  DeepLinkRequestedAction,
  Obs,
  Store,
} from '../types';

import { Observable } from 'rxjs';

/** @ignore **/
export function linkFunction(data: Object): Promise<string> {
  if (typeof window.branch !== 'undefined') {
    return new Promise((resolve, reject) => {
      window.branch.link(data, (error, link) =>
        error ? reject(error) : resolve(link),
      );
    });
  } else {
    return new Promise((resolve, reject) => {
      getBranchSDK().then(branch =>
        window.branch.link(data, (error, link) =>
          error ? reject(error) : resolve(link),
        ),
      );
    });
  }
}

type DeepLinkEpicObserver = ActionObserver<DeepLinkRequestedAction>;
export default function deepLink(
  action$: DeepLinkEpicObserver,
  store: Store,
): Obs {
  return action$
    .ofType(DEEP_LINK_REQUESTED)
    .switchMap(({ payload: { id, data } }) =>
      Observable.fromPromise(linkFunction(data)).map(deepLink =>
        deepLinkReceived(id, deepLink),
      ),
    )
    .catch(err => Observable.empty());
}
